// =========================================================================
// ZENTRALE MEHRWERTSTEUER-KONFIGURATION (Frontend)
// =========================================================================
// Diese Datei ist der EINZIGE Ort, an dem die Mehrwertsteuersätze im Frontend
// festgelegt werden. Alle Angebots-/Rechnungs-/Auftragsbestätigungs-
// Komponenten leiten sich hiervon ab (Import aus `../lib/vatConfig`).
//
// Regelbesteuerung (keine Kleinunternehmerregelung):
//   • B2B-Mietkocheinsätze (Dienstleistung an Betriebe) → 19 % Regelsatz
//   • Privatkoch-Leistungen (Menü-Abende, Verpflegung Privatkunden,
//     § 12 Abs. 2 UStG) → 7 % ermäßigter Satz
//
// Bei gesetzlicher Änderung hier UND in /app/backend/server.py anpassen.
// =========================================================================

export const MWST_RATE_PERCENT = 19;                     // Regelsatz (Standard)
export const MWST_RATE = MWST_RATE_PERCENT / 100;        // 0.19
export const MWST_RATE_PERCENT_REDUCED = 7;              // Privatkoch B2C
export const MWST_RATE_REDUCED = MWST_RATE_PERCENT_REDUCED / 100;

/** 7 % für Privatkoch-Kunden ("private"), sonst 19 % Regelsatz. */
export function taxRateForCustomerType(customerType) {
  return customerType === "private" ? MWST_RATE_PERCENT_REDUCED : MWST_RATE_PERCENT;
}

/** Gibt das MwSt-Label einer Positionsliste zurück.
 *  - Alle Positionen gleicher Rate: "19 % MwSt"
 *  - Gemischte Raten: "MwSt"
 */
export function mwstLabelFromItems(items) {
  const rates = new Set(
    (items || []).map((it) => Math.round(Number(it?.tax_rate ?? MWST_RATE_PERCENT)))
  );
  if (rates.size === 0) return `${MWST_RATE_PERCENT} % MwSt`;
  if (rates.size === 1) return `${[...rates][0]} % MwSt`;
  return "MwSt";
}

/** Netto/MwSt/Brutto exakt wie LexOffice: Zeilensummen in Cent, MwSt je
 *  Steuersatz-Gruppe kaufmännisch gerundet (verhindert 1-Cent-Abweichungen). */
export function calcVatTotals(items, defaultRate = MWST_RATE_PERCENT) {
  const groups = {};
  let netCents = 0;
  (items || []).forEach((it) => {
    const rate = Number(it?.tax_rate ?? defaultRate) || 0;
    const cents = Math.round(Number(it?.quantity || 0) * Number(it?.unit_price_net || 0) * 100);
    netCents += cents;
    groups[rate] = (groups[rate] || 0) + cents;
  });
  let vatCents = 0;
  Object.entries(groups).forEach(([rate, cents]) => {
    const raw = (cents * Number(rate)) / 100;
    vatCents += raw < 0 ? -Math.round(-raw) : Math.round(raw);
  });
  return {
    netSum: netCents / 100,
    mwstSum: vatCents / 100,
    grossSum: (netCents + vatCents) / 100,
  };
}

/** Berechnet Brutto einer Positionsliste, jede Position mit ihrer eigenen tax_rate. */
export function grossFromItems(items) {
  return calcVatTotals(items).grossSum;
}

/** Berechnet MwSt-Summe einer Positionsliste (pro Position). */
export function mwstFromItems(items) {
  return calcVatTotals(items).mwstSum;
}
